import type { Messages } from '@lingui/core';
import { mergeCatalogs } from './mergeCatalogs';

export const catalogs = mergeCatalogs(import.meta.glob<Messages>('./locales/*/*.po', {
  eager: true,
  import: 'messages',
}));
